import api from '@/utils/api'

let time = {
  delta: 0,
  fetch () {
    api.get('serverTimeDelta', {params: {clientTime: new Date().getTime() / 1000}}).then((response) => {
      this.delta = response.data.serverTimeDelta || 0
    }).catch(() => {
      this.delta = 0
    })
  },
  getServerTimeDelta () {
    return this.delta
  }
}

time.fetch()

export default time



// WEBPACK FOOTER //
// ./src/utils/timeService.js